import client from '../httpClient';

// common: /along-railways 沿線一覧取得
const alongRailwaysApi = (params) => {
  const GET_ALONG_RAILWAYS_URL = '/common/railways';
  return client.get(GET_ALONG_RAILWAYS_URL, { params });
};

export default alongRailwaysApi;
